import React, { useId } from 'react';
import './WaterDroplet.scss';

type Props = {
  size?: number;
  className?: string;
};

export default function WaterDroplet({ size = 16, className }: Props) {
  const gradId = `wd-${useId().replace(/:/g, '')}`;

  return (
    <svg
      className={`water-droplet${className ? ` ${className}` : ''}`}
      width={size}
      height={size}
      viewBox="-13 -13 26 26"
      aria-hidden="true"
    >
      <defs>
        {/* Soft centered radial gradient — calm, flat, stylized */}
        <radialGradient id={gradId} cx="50%" cy="50%" r="50%">
          <stop offset="0%"   stopColor="#cce8fb" stopOpacity={1} />
          <stop offset="100%" stopColor="#148de7" stopOpacity={1} />
        </radialGradient>
      </defs>

      {/* Circle */}
      <circle cx="0" cy="0" r="10" fill={`url(#${gradId})`} />
    </svg>
  );
}
